import {Injectable} from "@angular/core";



/*
 * category
 */

export interface Category {
  id?: number;
  label?: string;
  image?: string;
  subCategories?: Category[];

}





const categories: Category[] = [];

const bestCategories: Category[] = [
  {
    id: 3,
    label: 'Imprimantes',
    image: 'assets/images/categories/imprimante.png',
    subCategories: [
      {label: 'Imprimantes multifonctions', id: 50},
      {label: 'Imprimantes mono-fonction', id: 51},
      {label: 'Imprimante 3D', id: 149},
    ]
  },
  {
    id: 54,
    label: 'Consommables',
    image: 'assets/images/categories/consommables.png',
    subCategories: [
      {label: 'Encre d\'impression', id: 119},
      {label: 'Toner', id: 47},
      // {label: 'Papier d\'impression', id: 106},
      {label: 'Cartouches d\'encre', id: 54},
    ]
  },
  {
    id: 1,
    label: 'Ordinateurs',
    image: 'assets/images/categories/ordinateurs.png',
    subCategories: [
      {label: 'Ordinateur portable', id: 13},
      {label: 'Ordinateur de bureau', id: 20},
      {label: 'Périphériques', id: 33},
    ]
  },
  {
    id: 4,
    label: 'Logiciels',
    image: 'assets/images/categories/logiciels.png',
    subCategories: [
      {label: 'Antivirus', id: 60},
      {label: 'Systèmes d\'exploitation', id: 59},
      {label: 'Jeux', id: 62},
    ]
  },
];


@Injectable()
export class MenutItems {
  getBestCategories(): Category[] {
    return bestCategories;
  }

  getCategories(): any[] {
    return categories;
  }

}
